/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: (props) => ({
        container: {
            minWidth: 'xs',
            width: 'full',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            paddingLeft: 4,
            display: {base: 'none', lg: 'flex'}
        },
        stackContainer: {
            whiteSpace: 'nowrap',
            flexWrap: 'wrap'
        },
        popoverContent: {
            marginLeft: 'auto',
            marginRight: 'auto',
            border: 0,
            boxShadow: 'xl',
            paddingTop: 3,
            paddingRight: 4,
            paddingBottom: 4,
            paddingLeft: 4,
            minWidth: '100%',
            borderRadius: 0,
            position: 'absolute'
        },
        popoverContainer: {
            paddingTop: 0,
            paddingBottom: 8,
            paddingLeft: 0,
            paddingRight: 0,
            maxWidth: 'container.xxxl'
        },
        listMenuTriggerContainer: {
            display: 'flex',
            alignItems: 'center'
        },
        listMenuTriggerLink: {
            display: 'block',
            whiteSpace: 'nowrap',
            position: 'relative',
            paddingTop: {base: 3, lg: props.isShrunk ? '18px' : 11},
            paddingRight: 1,
            paddingLeft: 1,
            paddingBottom: {base: 2, lg: props.isShrunk ? '18px' : 11},
            transition: 'padding-top 0.3s ease-in-out, padding-bottom 0.3s ease-in-out',
            marginLeft: 3,
            fontSize: 'md',
            fontWeight: 400,
            lineHeight: '20px',
            borderBottomWidth: '3px',
            borderBottomStyle: 'solid',
            borderColor: 'transparent',
            color: props.isActive ? 'white' : 'gray.500',
            _hover: {
                borderImage:
                    'linear-gradient(90deg, rgba(254, 163, 11, 0) 0%, rgba(254, 163, 11, 1) 50%, rgba(254, 163, 11, 0) 100%) 1',
                color: 'white'
            }
        },
        listMenuTriggerLinkActive: {
            textDecoration: 'none',
            _before: {
                position: 'absolute',
                backgroundColor: 'black',
                content: 'attr(name)',
                height: '2px',
                color: 'transparent',
                bottom: '0px'
            }
        },
        listMenuTriggerLinkIcon: {
            marginTop: 0,
            marginRight: 3,
            marginBottom: props.isShrunk ? 0 : 2,
            marginLeft: 0,
            paddingTop: {lg: props.isShrunk ? '9px' : 9},
            paddingBottom: {lg: props.isShrunk ? '14px' : 9},
            _hover: {
                textDecoration: 'none'
            }
        },
        selectedButtonIcon: {
            color: 'gray.500'
        }
    }),
    parts: [
        'container',
        'stackContainer',
        'popoverContent',
        'popoverContainer',
        'listMenuTriggerContainer',
        'listMenuTriggerLink',
        'listMenuTriggerLinkActive',
        'listMenuTriggerIcon',
        'selectedButtonIcon'
    ]
}
